import React from "react";
import styled, { keyframes } from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import Header from "../headers/light.js";
import Countdown from 'react-countdown';
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import DesignIllustration from "../../images/babykraken_only_450px-min.png";
import Features10 from "components/features/ThreeColSimple10.js";
const PrimaryButton = tw.button`font-bold px-8 lg:px-10 py-3 rounded bg-green-500 text-white hocus:bg-green-600 focus:shadow-outline focus:outline-none transition duration-300`;

const Form = tw.form`text-xs max-w-sm sm:max-w-none mx-auto`
const Input = tw.input`w-11/12 sm:w-11/12 text-center block sm:inline-block  py-2 mt-2 rounded bg-secondary-200 tracking-wider font-bold border border-secondary-600 focus:border-secondary-300 focus:outline-none sm:rounded-r-none hover:bg-secondary-500 transition duration-300 text-gray-200`



//const rotate360 = keyframes`
//  from {
//    transform: rotate(0deg);
//  }
//  to {
//    transform: rotate(360deg);
//  }
//`;

//const Spinner = styled.div`
//  animation: ${rotate360} 4s linear infinite;

//`;

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const ThreeColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24`;

const LeftColumn = tw.div`relative lg:w-4/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const MiddleColumn = tw.div`relative lg:w-4/12 mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-start`;
const RightColumn = tw.div`relative lg:w-4/12 mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-start`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;

const Actions = styled.div`
  ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
  input {
    ${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300  focus:border-primary-500 hover:border-gray-500`}
  }
  button {
    ${tw`w-full sm:absolute right-0 top-0 bottom-0 bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center sm:w-40 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`}
  }
`;

const IllustrationContainer = tw.div`flex justify-center lg:justify-center items-center`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;


export default ({
  roundedHeaderButton,
  primaryButtonText1="Buy",
  primaryButtonText3="Telegram",
  primaryButtonText4="Chart",
  primaryButtonUrl1="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x4D79DA6F390D9E9d475802a693353C3715b7Bd75",
  primaryButtonUrl3="https://t.me/babykrakentoken",
  primaryButtonUrl4="https://www.dextools.io/app/pancakeswap/pair-explorer/0x4b903f3B2C849a2D35f646da3B1dD3B06B00748e",
 }) => {

   const Subheading = tw.span`uppercase tracking-widest font-bold text-green-500`;
   const HighlightedText = tw.span`text-green-500`;
   const startDate = Date.now()
   console.log("check date, ", startDate)
  return (
    <>
      <Header roundedHeaderButton={roundedHeaderButton} />


      <Features10
        subheading={<Subheading>COUNTDOWN FOR THE BUYBACK TO INCREASE TO 0.25 BNB</Subheading>}
        heading={
          <Countdown date='2021-07-02T00:30:00.000Z' />
        }

      />

      <Features10
        subheading={<Subheading>COUNTDOWN FOR THE BUYBACK TO INCREASE TO 1 BNB</Subheading>}
        heading={
          <Countdown date='2021-07-02T21:30:00.000Z' />
        }

      />



      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              A <span tw="text-green-500">perfected </span>version of the EverRise contract.
            </Heading>
            <Paragraph>
            Meet BabyKraken - a perfected version of the EverRise contract. BabyKraken brings together EverRise and SafeMoon tokenomics, with a more robust buyback mechanism which can't be exploited by spamming transactions. A DAO-owned contract means our coin can grow, guided by the community.
            </Paragraph>
            <Paragraph>
            BSC contract address:

            <Form>
              <Input name="contract" type="text" value="0x4D79DA6F390D9E9d475802a693353C3715b7Bd75" />
            </Form>
            </Paragraph>

            <ThreeColumn>
              <LeftColumn>
            <Actions>
              <PrimaryButton as="a" href={primaryButtonUrl1}>{primaryButtonText1}</PrimaryButton>
            </Actions>
            </LeftColumn>

            <MiddleColumn>
          <Actions>
            <PrimaryButton as="a" href={primaryButtonUrl4}>{primaryButtonText4}</PrimaryButton>
          </Actions>
          </MiddleColumn>


            <RightColumn>
            <Actions>
            <PrimaryButton as="a" href={primaryButtonUrl3}>{primaryButtonText3}</PrimaryButton>
            </Actions>
            </RightColumn>
            </ThreeColumn>




          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              <img src={DesignIllustration} alt="Design Illustration" />
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
        <DecoratorBlob1 />
      </Container>
    </>
  );
};
